export default __webpack_public_path__ + "media/images/icons/icon-sandwich-e477142a11af4932671b4d993b9abf5e.svg";